import { useContext } from 'react';
import MobileThemeContext from './MobileThemeContext';

function useIsMobile() {
  const { isMobile } = (useContext(MobileThemeContext) ?? { isMobile: false });
  return isMobile;
}

export default useIsMobile;
